<template>
  <div id="locked-modal" class="modal-demo">
    <h4 class="custom-modal-title">Session verrouillée</h4>
    <div class="custom-modal-text">
      <gravatar :email="user.email" alt="user" class="img-circle center-block m-b-10"></gravatar>
      <p class="text-muted text-center">{{ user.name }}</p>

      <p>
        Votre session de travail a été verrouillée manuellement ou automatiquement pour cause d'inactivité.
        Pour vous re-connecter, cliquez simplement sur le bouton reconnexion ci-dessous.
      </p>

      <div class="m-t-30 m-b-5">
        <el-button type="primary" class="waves-effect waves-light" style="display: block; margin: auto" @click="close">Reconnexion</el-button>
      </div>
    </div>
  </div>
</template>

<script>
  let $ = window.$
  let Custombox = window.Custombox

  import gravatar from 'vue-gravatar'
  import { events } from '../../services/event-bus.js'

  export default {
    name: 'locked-modal',
    components: {
      gravatar
    },
    data () {
      return {
        locked: false
      }
    },
    created () {
      let self = this

      $(document).idle({
        onIdle: () => {
          if (!self.locked) {
            self.open()
          }
        },
        idle: 1000 * 60 * 10
      })

      events.on('app/ui/locked', () => {
        self.open()
      })
      events.on('app/ui/unlocked', () => {
        self.close()
      })
    },
    computed: {
      user () {
        return this.$store.getters['users/current']
      }
    },
    methods: {
      open () {
        this.locked = true
        this.$nexus.post('callcenter', 'users/' + this.user.id + '/activity/LOCKED')
        Custombox.open({
          target: '#locked-modal',
          effect: 'blur',
          escKey: false,
          overlayOpacity: 0.2,
          overlayClose: false
        })
      },
      close () {
        this.locked = false
        Custombox.close()
      }
    }
  }
</script>



// WEBPACK FOOTER //
// LockedModal.vue?959b3f52